// DO NOT PUT SECRETS IN HERE!!!
const staging = {
  flags: {
    enableEuSettingsPopup: true,
    enableHomepage: true,
    enableHomepageTabs: false,
    enableInitialReadoutExperience: true,
    enableKeywordsOnSharedTopicReport: true,
    enableSalesforceIntegration: true,
    enableSpanishLocale: true,
    googleReview: false,
    enableMobileNav: true,
  },
  FRONTEND_URL: "https://stg-app.read.ai",
  RECORDINGS_URL: "https://stg-recordings.read.ai",
  RSS_LINKS_URL: "https://stg-cal.read.ai",
  api: {
    HOST: "https://stg-api.read.ai",
    disableMetricsQueries: false,
  },
  tracking: {
    GOOGLE_ID: "G-JQN958QXJF",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    STATSIG_KEY: "client-ntzxY8eFoeabjvRLm0AvTF1uFPkb9X7Qu8w1EmeRKH1",
  },
  stripe: {
    publishableKey:
      "pk_test_51LB55RKEmPi2JwflCpilDUymp0vQWHIR7U2mMrUEZBqNlXHfdPMBec78tRyEWFlL2y8G5wFCuVF0KgNypBB5k4kK007gYtiU11",
    subscriptionCheckoutReturnUrl:
      "https://stg-api.read.ai/billing/checkout-confirm-return",
    creditCheckoutReturnUrl:
      "https://stg-api.read.ai/billing/credit-checkout-confirm-return",
    setupReturnUrl: "https://stg-api.read.ai/billing/setup-confirm-return",
  },
  billing: {
    zeroBalancePriceIds: [
      "price_1M5H30KEmPi2JwflDrJv1i1R", // Read Free
      "price_1MFPTMKEmPi2JwflboZ0d3Oz", // Read Zoom
    ],
    prices: {
      byPriceId: {
        // updated prices
        price_1NuLglKEmPi2JwflT8dFtG1e: 39.75, // monthly enterprise+
        price_1NwtDMKEmPi2JwflOoRsV3Xu: 29.75, // annual enterprise+
        price_1NZz6bKEmPi2JwflxbtLnakM: 29.75, // monthly enterprise
        price_1NZz5mKEmPi2JwflRJmQNiOM: 22.5, // annual enterprise
        price_1NZz85KEmPi2JwflFQyb68bJ: 19.75, // monthly pro
        price_1NZz7nKEmPi2JwflH21Vb6oL: 15, // annual pro
        // legacy prices (do not remove a price from here unless there are 0 active subscriptions with these price ids!)
        price_1M5Gy5KEmPi2Jwfl7Ko3H4im: 25, // monthly enterprise
        price_1MHDQnKEmPi2JwflO9OeJxhg: 16.5, // annual enterprise
        price_1MHDPgKEmPi2JwflclMIvltK: 10, // annual pro
        price_1M5GxKKEmPi2JwflOpKMMBhP: 15, // monthly pro
      } as Record<string, number | undefined>,
    },
    promotions: {
      trial_extension_on_purchase: "40493448ADC937A620340AFA4",
    },
  },
  apps: {
    zoom: {
      INSTALL_URL: "https://stg-api.read.ai/zoomapp/install",
    },
    teams: {
      AAD_CLIENT_ID: "35e7f5d2-9978-464f-8710-c7a05d5b9fdf",
      APP_ID: "bc2ba891-7e13-4180-a385-77c81c460d8a",
    },
    meet: {
      ENABLE_MOCK_CLIENT: false,
      CLOUD_PROJECT_NUMBER: "744026649565",
      CLIENT_ID:
        "307358853148-pfp68q0vqgukrgevecaa3k4e34742hoq.apps.googleusercontent.com",
    },
  },
  statusMessage: {
    enabled: [],
  },
  // Test key
  recaptchaSite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};

export type Config = typeof staging;

export default staging;
